import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {languagesData} from 'data/languages-data';
import './language-select-dropdown.scss';

const LanguageSelectDropdown = ({languageId, layout, deviceInfo, handleSelectLanguage}) => {

	const [showOptions, setShowOptions] = useState(false);

	const selectLanguage = (newLangaugeId) => {
		handleSelectLanguage(newLangaugeId);
		setShowOptions(false);
	};

	return (
		<div className={'LanguageSelectDropdown ' + layout + ' ' + deviceInfo.orientation} >
			<div 	
				className={'LanguageSelectDropdown-current ' + languageId}
				onClick={() => {setShowOptions(!showOptions);}}
			/>
			
			<div className={'LanguageSelectDropdown-dropdown' + (showOptions ? ' open' : '')}>
				{languagesData.map((languageData) => {
					if (languageId === languageData.id) return null;
					return (
						<div 
							key={languageData.id}
							onClick={() => {selectLanguage(languageData.id);}}
							className={'LanguageSelectDropdown-option ' + languageData.id}>
						</div>
					);
				})}
			</div>

		</div>
	);
};

LanguageSelectDropdown.propTypes = {
	languageId: PropTypes.string.isRequired,
	layout: PropTypes.string,
	deviceInfo: PropTypes.object.isRequired,
	handleSelectLanguage: PropTypes.func.isRequired
};

export default LanguageSelectDropdown;